import moment from 'moment'
import { FORMATS, TYPES } from '@/entities/fields'
import { formats } from '@/components/Forms/WDatepicker/utils'

// v-calendar parses typed dates with the browser language format by default
// (MM/DD/YYYY in an English browser). Read them as the grid displays them.
export const DATE_PICKER_FORMATS = {
    ...formats,
    input: [FORMATS[TYPES.DATE], 'YYYY-MM-DD', 'YYYY/MM/DD'],
}

export const DATE_PLACEHOLDER = FORMATS[TYPES.DATE]

export const toPickerDate = (value) => {
    const date = moment(value)
    return value && date.isValid() ? date.toDate() : null
}

// Send the calendar day only, so no timezone can shift it on its way to the API.
export const toApiDate = date => (date ? moment(date).format('YYYY-MM-DD') : null)

export const formatDate = (value) => {
    const date = moment(value)
    return date.isValid() ? date.format(FORMATS[TYPES.DATE]) : value
}
